module.exports = __webpack_public_path__ + "media/bootstrap-icons/speaker-bc352f7f.svg";